import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IHallBookingBill } from "src/domain/entities"
import { hallBookingBillDeleteService } from "src/domain/services/hallBookingBill/hallBookingBillDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	hallBookingBill: IHallBookingBill
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const HallBookingBillDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	hallBookingBill,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await hallBookingBillDeleteService({ id: hallBookingBill.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [hallBookingBill, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Hall Booking Bill #${hallBookingBill.billNo}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
